import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";

class LinkSendWillMount extends Middleware implements MiddlewareInterface {
  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const id: number = parseInt(this.component.props.params.id, 10);
		const entity: string = this.component.props.params.entity;
		const person = this.component.props.app.persons.find((person: PersonInterface) => person.id === id);
		
		this.component.setState({
			userId: id,
			userType: entity,
			person: person,
			emailTo: person?.email
		})
  }
}

export default new LinkSendWillMount();
